import { TestMessagingSection } from '../'

/**
 * Test Tab — send yourself a real message and read what a customer would read.
 *
 * `settings-consolidation.md` §3.6 gives Test its own destination ("TestMessagingSection —
 * unchanged"). It was rendered at the bottom of the Touchpoints tab, which MAR-112 deleted;
 * moving it out first is what stopped the deletion taking it along.
 *
 * ⚠️ Both sends are real. `POST /email/test` invokes `shopper-email` with `testMode: true`,
 * and `POST /sms/test` invokes `sms-sender` with `sendKind: 'merchant_test'` (MAR-159: a named
 * kind, which runs only "Twilio configured" and "valid number") — so an SMS test ignores quiet hours and the caps set on the Limits tab. The section's own copy says "real",
 * but not that; a merchant reading a test through at 2am would have no way to know the limits
 * they just set did not apply — and Limits is now one tab away. Carried as MAR-153.
 */
const TestTab = () => <TestMessagingSection />

export default TestTab
